import { Icon } from "@/components/Icon";
import { openTelegramUserLink } from "@/lib/openExternal";

/**
 * Контакт «Відкрити пост у Telegram» (owner 2026-09-24).
 *
 * Вакансія з чату, у якої немає ні ніка автора, ні телефону, ні пошти:
 * автор без ніка, пост від імені групи або автор прихований при пересиланні.
 * Єдиний спосіб звʼязатися — відкрити сам пост у групі й написати звідти.
 * Посилання рахує сервер (`post_url`), тут лише малюємо рядок у тому ж
 * стилі, що й інші посилання в блоці контактів.
 */
export default function PostLinkRow({ url }: { url: string }) {
  const display = url.replace(/^https?:\/\//, "").replace(/\/$/, "");
  return (
    <button
      type="button"
      onClick={() => openTelegramUserLink(url)}
      className="w-full flex items-center gap-3 px-3.5 py-2.5 rounded-xl border border-ink/[0.08] active:bg-surface-soft transition text-left"
    >
      <div className="grid h-9 w-9 place-items-center rounded-full shrink-0 bg-primary/10 text-primary">
        <Icon name="post" size={16} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-display text-[0.6875rem] font-semibold uppercase tracking-[0.04em] text-ink whitespace-nowrap truncate">
          Відкрити пост у Telegram
        </div>
        <div className="font-mono text-[0.71875rem] text-ink-dim mt-0.5 truncate">
          {display}
        </div>
      </div>
      <Icon name="arrow-right" size={14} color="rgba(254,107,4,0.85)" className="-rotate-45" />
    </button>
  );
}
